import { Formio } from '@formio/angular';
const Components = (Formio as any).Components;
const Base = (Formio as any).Components.components.checkbox;
const Templates = (Formio as any).Templates;

// Переопределяем шаблон для нашего компонента
Templates.current.sliderBoolean = {
  form: (ctx: any) => `
  <label class="ikbs-switch">
    <input
      ref="input"
      type="checkbox"
      class="form-check-input ikbs-sw-input"
      ${ctx.component.disabled ? 'disabled' : ''}
      ${ctx.checked ? 'checked' : ''}
    />
    <span class="ikbs-slider round"></span>
  </label>
       <label class="ikbs-slider-text"> ${ctx.component.label || ''}</label>

`
};
export default class SliderBooleanComponent extends Base {
  static schema() {
    return Base.schema({
      type: 'SliderBooleanComponent',
      inputType: 'checkbox',
      label: 'Slider boolean',
      key: 'sliderBoolean',
      dataGridLabel: true,
      labelPosition: 'right',
      value: false
    });
  }

  static get builderInfo() {
    return {
      title: 'Slider boolean',
      group: 'basic',
      icon: 'check-square',
      documentation: '/userguide/form-building/form-components#check-box',
      weight: 50,
      schema: SliderBooleanComponent.schema()
    };
  }

  render() {
    // Временно сохраняем оригинальный шаблон
    const originalTemplate = Templates.current.checkbox;
    // Подменяем на наш шаблон
    Templates.current.checkbox = Templates.current.sliderBoolean;

    // Используем базовый render с нашим шаблоном
    const result = super.render();

    // Восстанавливаем оригинальный шаблон
    Templates.current.checkbox = originalTemplate;

    return result;
  }

  get inputInfo() {
    const info = super.elementInfo();
    info.type = 'input';
    info.changeEvent = 'click';
    info.attr.type = 'checkbox';
    info.attr.class = 'form-check-input ikbs-sw-input';
    info.attr.value = this['dataValue'];
    info.label = this['t'](this['component'].label, { _userInput: true });
    return info;
  }

  get emptyValue() {
    return false;
  }
}

Components.addComponent('SliderBooleanComponent', SliderBooleanComponent);
